const utils = {
  isProduction: process.env.REACT_APP_ENV === 'PROD',
  isDemo: process.env.REACT_APP_ENV === 'DEMO',
  isDevelopment: process.env.REACT_APP_ENV === 'DEV',
};

export default utils;
